import { render, staticRenderFns } from "./EstablishmentViewLogs.vue?vue&type=template&id=10ae75f0"
import script from "./EstablishmentViewLogs.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports